module.exports = __webpack_public_path__ + "img/ios_navigation_action_blue.883d1e2c.png";